import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'

import { useLocations } from '@/composables/locations.js'
import { partnerPortsQuery, transitEnabledMarketsQuery } from '@/utilities/megalithQueries'
import { PRODUCT_TYPE_MEGAPORT } from '@/Globals'

export function useTransitPorts() {
  const { data: partnerPorts } = useQuery(partnerPortsQuery())

  const transitPorts = computed(() => {
    return partnerPorts.value
      ?.filter(({ connectType }) => connectType === 'TRANSIT')
      .map(({ connectType, locationId, speed, title }) => {
        const rateLimit = Math.max(speed, 0)

        return {
          connectType,
          id: Number.parseInt(locationId),
          rateLimit,
          title,
          _aggSpeed: rateLimit, // Transit ports should never be in a LAG (knock on wood)
        }
      })
  })

  const { data: transitEnabledMarkets } = useQuery(transitEnabledMarketsQuery())

  const { enhancedLocations } = useLocations()

  /**
   * Returns a version of the transit ports enhanced with the full information that is required in the UI.
   */
  const enhancedTransitPorts = computed(() => {
    return transitPorts.value?.map(transitPort => {
      // Get the location details for this port
      const { dataCentre, market, metro, formatted } = enhancedLocations.value.find(({ id }) => id === transitPort.id)
      // All transit ports are by definition ports
      const serviceType = PRODUCT_TYPE_MEGAPORT

      return { ...transitPort, dataCentre, formatted, market, metro, serviceType }
    })
  })

  return {
    enhancedTransitPorts,
    transitPorts,
    transitEnabledMarkets,
  }
}
